import React from "react";
import "./NewsletterSection.css";

const NewsletterSection = () => {
  return (
    <section className="modern-newsletter-section">
      <div className="modern-newsletter-container">
        <h2 className="modern-newsletter-title">Stay Updated</h2>
        <p className="modern-newsletter-subtitle">
          Subscribe to our newsletter for job alerts and career tips.
        </p>
        <div className="modern-newsletter-iframe-wrapper">
          <iframe
            src="https://anuragsingal.substack.com/embed"
            className="modern-newsletter-iframe"
            frameBorder="0"
            scrolling="no"
            title="Newsletter Subscription"
          />
        </div>
      </div>
    </section>
  );
};

export default NewsletterSection;
